import axios from '@/base/api/axios'

export default {
  async create (data) {
    return (await axios.post('/api/auth/user/', data)).data
  },

  async get () {
    return (await axios.get('/api/auth/user/')).data
  },

  async save (obj) {
    let data = obj
    if (obj.photo) {
      data = new FormData()
      data.append('photo', obj.photo, 'photo.jpeg')
    }
    return (await axios.patch('/api/auth/user/', data)).data
  },

  delete () {
    return axios.delete('/api/auth/user/')
  },

  async getFailedEmailDeliveries () {
    return (await axios.get('/api/auth/user/failed_email_deliveries/')).data.results
  },
}
